// extracted by mini-css-extract-plugin
export var formPattern = "contact-form-module--formPattern--14BR_";
export var contactForm = "contact-form-module--contactForm--1SXAN";
export var fieldsContainer = "contact-form-module--fieldsContainer--2ONaF";
export var labelText = "contact-form-module--labelText--1rdbm";
export var errorText = "contact-form-module--errorText--18LEc";